import axios from '@axios'

export default {
  listBoleto: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/cobrancas/${pagina}`),
}
